function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Service from '@ember/service';
var _positions = /*#__PURE__*/new WeakMap();
export default class PreserveScrollService extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateFieldInitSpec(this, _positions, {});
  }
  savePosition(key, position) {
    _classPrivateFieldGet(_positions, this)[key] = position;
  }
  getPosition(key) {
    return _classPrivateFieldGet(_positions, this)[key] ?? 0;
  }
  clearPosition(key) {
    delete _classPrivateFieldGet(_positions, this)[key];
  }
}